import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { applyGlobalChartTheme } from './app/core/services/chartConfiguration/chart-theme';

applyGlobalChartTheme();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
